import React from 'react';
import {useState,useEffect,Component} from 'react';
import { useNavigate } from 'react-router-dom';
import { BrowserRouter as Router,Routes,Route,Link} from 'react-router-dom';
import axios from '../axios.js';
import moment from 'moment/moment';

import './Resources/dashboard.css';
import Navbar from './Supportingfiles/navbar';
import Sidebar from './Supportingfiles/sidebar';
import Create_bank from './create_bank';
import Add_bank from './add_bank';


import Chart from "chart.js/auto";
import { Line, Bar } from "react-chartjs-2";

import {useRef as useref} from 'react';
import {useReactToPrint} from 'react-to-print';

//EXCEL DOWNLOAD IMPORT
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';
import Create_sales from './create_sales.js';
import Add_vendor from './add_vendor.js';

function SP_vendors(){

 //Report Print Function
 const componentRef = useref();
 const handlePrint = useReactToPrint({
   content: () => componentRef.current,
 });

 //Report Print Function 1
 const componentRef1 = useref();
 const handlePrint1 = useReactToPrint({
   content: () => componentRef1.current,
 });


 /*
 // Function to download the data as an Excel file
 const downloadExcel = () => {
  // Convert JSON data to Excel worksheet
  const worksheet = XLSX.utils.json_to_sheet(data);
  
  // Create a new workbook and add the worksheet
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");
  
  // Convert the workbook to a binary array
  const excelBuffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" });
  
  // Create a Blob from the binary data and trigger a download
  const excel_data = new Blob([excelBuffer], { type: "application/octet-stream" });
  saveAs(excel_data, "bank_data.xlsx");
};
*/

  
 //Checking Sessions
 // Access value associated with the login status
 const logstatus=sessionStorage.getItem("logStatus00");
 const logtype=sessionStorage.getItem("logType00");
 const logid=sessionStorage.getItem("logId00");
 const token=sessionStorage.getItem("logToken00");
 const busyid=sessionStorage.getItem("BusyId00");
 const counterid=sessionStorage.getItem("CounterId00");


 
 
{/* TRANSACTIONS TABLE COLUMNS MANAGEMENT VARIABLES START */}
const[cd_col1_val,setcd_col1_val] = useState(0);//column1
const[cd_col2_val,setcd_col2_val] = useState(0);//column2
const[cd_col3_val,setcd_col3_val] = useState(0);//column3
const[cd_col4_val,setcd_col4_val] = useState(0);//column4
const[cd_col5_val,setcd_col5_val] = useState(0);//column5
const[cd_col6_val,setcd_col6_val] = useState(0);//column6
const[cd_col7_val,setcd_col7_val] = useState(0);//column7
const[cd_col8_val,setcd_col8_val] = useState(0);//column8
const[cd_col9_val,setcd_col9_val] = useState(0);//column9
const[cd_col10_val,setcd_col10_val] = useState(0);//column10
const[cd_col11_val,setcd_col11_val] = useState(0);//column11
const[cd_col12_val,setcd_col12_val] = useState(0);//column12
{/*const[cd_col13_val,setcd_col13_val] = useState(0);//column13
const[cd_col14_val,setcd_col14_val] = useState(0);//column14 */}

{/* TRANSACTIONS TABLE COLUMNS MANAGEMENT VARIABLES END */}


 //Checking if Sessions are Set

// alert(logstatus,loguser,logadminid);
 //Sessions Not Set
 /*if(((logstatus==null)||(logstatus==""))||((logid==null)||(logid==""))||((token==null)||(token==" "))||((busyid==null)||(busyid==" "))||((counterid==null)||(counterid==" "))){
  
   sessionStorage.removeItem("logStatus00");
   sessionStorage.removeItem("logId00");
   sessionStorage.removeItem("logToken00");
   sessionStorage.removeItem("BusyId00");
   sessionStorage.removeItem("BusyName00");
   sessionStorage.removeItem("CounterId00");
   
 
    window.location.replace("/businesstools-login");
   }
  
   //Sessions Set
  else{ */



    
 //SETTING DEFAULT STATE VARIABLES FOR CHART */
 
      
//Variables
//const[banks,setbanks] = useState([]);//SetData Variable
//const[brokers,setbrokers] = useState([]);//SetData Variable
const[data,setData] = useState([]);//SetData Variable
//const[bank_summary,setbank_summary] = useState([]);//Setbank_summary Variable

//Error Variable
const[errorvar,seterrorvar] = useState();



//FILTER VARIABLES
const[filter_val,setfilter_val] = useState(0);
//const[filter_start_date,setfilter_start_date] = useState('1970-01-01'); const updatefilter_start_date = (event) => { setfilter_start_date(event.target.value);}; const[filter_start_date_er,setfilter_start_date_er]=useState();
//const[filter_end_date,setfilter_end_date] = useState('2100-12-12'); const updatefilter_end_date = (event) => { setfilter_end_date(event.target.value);}; const[filter_end_date_er,setfilter_end_date_er]=useState();
const[filter_customer_id,setfilter_customer_id] = useState(); const updatefilter_customer_id = (event) => { setfilter_customer_id(event.target.value);}; const[filter_customer_id_er,setfilter_customer_id_er]=useState();
const[filter_customer_name,setfilter_customer_name] = useState(); const updatefilter_customer_name = (event) => { setfilter_customer_name(event.target.value);}; const[filter_customer_name_er,setfilter_customer_name_er]=useState();
const[filter_email,setfilter_email] = useState(); const updatefilter_email = (event) => { setfilter_email(event.target.value);}; const[filter_email_er,setfilter_email_er]=useState();
const[filter_contact,setfilter_contact] = useState(); const updatefilter_contact = (event) => { setfilter_contact(event.target.value);}; const[filter_contact_er,setfilter_contact_er]=useState();
const[filter_trade_name,setfilter_trade_name] = useState(); const updatefilter_trade_name = (event) => { setfilter_trade_name(event.target.value);}; const[filter_trade_name_er,setfilter_trade_name_er]=useState();
const[filter_address,setfilter_address] = useState(); const updatefilter_address = (event) => { setfilter_address(event.target.value);}; const[filter_address_er,setfilter_address_er]=useState();
const[filter_city,setfilter_city] = useState(); const updatefilter_city = (event) => { setfilter_city(event.target.value);}; const[filter_city_er,setfilter_city_er]=useState();
const[filter_state,setfilter_state] = useState(); const updatefilter_state = (event) => { setfilter_state(event.target.value);}; const[filter_state_er,setfilter_state_er]=useState();
const[filter_country,setfilter_country] = useState(); const updatefilter_country = (event) => { setfilter_country(event.target.value);}; const[filter_country_er,setfilter_country_er]=useState();
const[filter_type,setfilter_type] = useState(); const updatefilter_type = (event) => { setfilter_type(event.target.value);}; const[filter_type_er,setfilter_type_er]=useState();
const[filter_category,setfilter_category] = useState(); const updatefilter_category = (event) => { setfilter_category(event.target.value);}; const[filter_category_er,setfilter_category_er]=useState();


//Variables for pagination
const [currentPage, setCurrentPage] = useState(1);
const [pageNumber, setpageNumber] = useState(1);


useEffect(()=>{
   
  getData();
  
  },[])
 
    
  
//******************* GET SALES DATA FUNCTION START  ********************//
function getData(){
 

  //Checking if user loggedin
  if(((logstatus!=null)||(logstatus!=""))&&((logid!=null)||(logid!=""))&&((token!=null)||(token!=" "))){
 
      //Fetching Filter Variables
      const $filter_customer_id = filter_customer_id;
      const $filter_customer_name = filter_customer_name;
      const $filter_email = filter_email;   
      const $filter_contact = filter_contact;
      const $filter_trade_name = filter_trade_name;
      const $filter_address = filter_address;
      const $filter_city = filter_city;
      const $filter_state = filter_state;
      const $filter_country = filter_country;
      const $filter_category = filter_category;
      const $filter_type = filter_type;
        
 
 axios.post("vendorslist", {
   Log_id:logid,
   Token:token,
   Sn_start :0,
   Sn_end :0,
   Sn_total :0,
   Sn_limit :0,

   //Filters
   Filter_val : filter_val,
 

   Filter_customer_id : $filter_customer_id,
   Filter_customer_name : $filter_customer_name,
   Filter_email : $filter_email,
   Filter_contact : $filter_contact,
   Filter_trade_name : $filter_trade_name,
   Filter_address : $filter_address,
   Filter_city : $filter_city,
   Filter_state : $filter_state,
   Filter_country : $filter_country,
   Filter_category : $filter_category,
   Filter_type : $filter_type,
  
   //Code Edits for pagination
  'page' : pageNumber

 })
 .then((response) => {

  //Invalid Session
  if((response.data.error)==100){ 
      //Remove Session Variables and redirect to login
     sessionStorage.removeItem("logStatus00");
     sessionStorage.removeItem("logId00");
     sessionStorage.removeItem("logToken00");
     sessionStorage.removeItem("BusyId00");
     sessionStorage.removeItem("CounterId00");

     window.location.replace("businesstools-login");
  }
  //Success Data Fetched
  if(response.data.successvar==1){
   //Setting Data
   
   setData(response.data.data.data);

  
  }
   //FILTER DATA
  //Validation Errors
  if(response.data.validatorerror){
  
    setfilter_customer_id_er(response.data.validatorerror.Filter_customer_id);
    setfilter_customer_name_er(response.data.validatorerror.Filter_customer_name);
    setfilter_email_er(response.data.validatorerror.Filter_email);
    setfilter_contact_er(response.data.validatorerror.Filter_contact);
    setfilter_trade_name_er(response.data.validatorerror.Filter_trade_name);
    setfilter_address_er(response.data.validatorerror.Filter_address);
    setfilter_city_er(response.data.validatorerror.Filter_city);
    setfilter_state_er(response.data.validatorerror.Filter_state);
    setfilter_country_er(response.data.validatorerror.Filter_country);
    setfilter_type_er(response.data.validatorerror.Filter_type);
    setfilter_category_er(response.data.validatorerror.Filter_category);

  }

  //Data Violation
  if(response.data.error==102){ 
  

    setfilter_customer_id_er(response.data.filter_customer_id_er);
    setfilter_customer_name_er(response.data.filter_customer_name_er);
    setfilter_email_er(response.data.filter_email_er);
    setfilter_contact_er(response.data.filter_contact_er);
    setfilter_trade_name_er(response.data.filter_trade_name_er);
    setfilter_address_er(response.data.filter_address_er);
    setfilter_city_er(response.data.filter_city_er);
    setfilter_state_er(response.data.filter_state_er);
    setfilter_country_er(response.data.filter_country_er);
    setfilter_type_er(response.data.filter_type_er);
    setfilter_category_er(response.data.filter_category_er);

  }
  //Cannot Fetch Data
  else{
   seterrorvar("Cannot Fetch Data !");
  }
 
 
 });
 
 }
 //User not Logedin
 else{
 
 //Remove Session Variables and redirect to login
   sessionStorage.removeItem("logStatus00");
   sessionStorage.removeItem("logId00");
   sessionStorage.removeItem("logToken00");
   sessionStorage.removeItem("BusyId00");
   sessionStorage.removeItem("CounterId00");

   window.location.replace("businesstools-login");
 
  }
 
 }
  
 //******************* GET VENDOR DATA FUNCTION END  ********************//



//ERROR VARIABLES 
const[error_msg,seterror_msg]=useState();



 //******************* GET VENDOR DATA BY ID FUNCTION START  ********************//

 //evendor_name
 const[evendor_name,setevendor_name]=useState();const updateevendor_name = (event) => { setevendor_name(event.target.value);}; const[evendor_name_er,setevendor_name_er]=useState();
 //eemail
 const[eemail,seteemail]=useState();const updateeemail = (event) => { seteemail(event.target.value);}; const[eemail_er,seteemail_er]=useState();
 //econtact
 const[econtact,setecontact]=useState();const updateecontact = (event) => { setecontact(event.target.value);}; const[econtact_er,setecontact_er]=useState();
 //etrade_name
 const[etrade_name,setetrade_name]=useState();const updateetrade_name = (event) => { setetrade_name(event.target.value);}; const[etrade_name_er,setetrade_name_er]=useState();
 //eaddress
 const[eaddress,seteaddress]=useState();const updateeaddress = (event) => { seteaddress(event.target.value);}; const[eaddress_er,seteaddress_er]=useState();
 //ecity
 const[ecity,setecity]=useState();const updateecity = (event) => { setecity(event.target.value);}; const[ecity_er,setecity_er]=useState();
 //ecstate
 const[ecstate,setecstate]=useState();const updateecstate = (event) => { setecstate(event.target.value);}; const[ecstate_er,setecstate_er]=useState();
 //ecountry
 const[ecountry,setecountry]=useState();const updateecountry = (event) => { setecountry(event.target.value);}; const[ecountry_er,setecountry_er]=useState();
 //epincode
 const[epincode,setepincode]=useState();const updateepincode = (event) => { setepincode(event.target.value);}; const[epincode_er,setepincode_er]=useState();
 //etype
 const[etype,setetype]=useState();const updateetype = (event) => { setetype(event.target.value);}; const[etype_er,setetype_er]=useState();
 //ecategory
 const[ecategory,setecategory]=useState();const updateecategory = (event) => { setecategory(event.target.value);}; const[ecategory_er,setecategory_er]=useState();
 //egstin
 const[egstin,setegstin]=useState();const updateegstin = (event) => { setegstin(event.target.value);}; const[egstin_er,setegstin_er]=useState();
 //elicense_no
 const[elicense_no,setelicense_no]=useState();const updateelicense_no = (event) => { setelicense_no(event.target.value);}; const[elicense_no_er,setelicense_no_er]=useState();
 
 
 //ebank_id
 const[ebank_id,setebank_id]=useState();const updateebank_id = (event) => { setebank_id(event.target.value);}; const[ebank_id_er,setebank_id_er]=useState();



//Edit Function
function getcounterdatabyId(){
 

  const bankid=sessionStorage.getItem("Bankid00");

  //Checking if user loggedin
  if(((logstatus!=null)||(logstatus!=""))&&((logid!=null)||(logid!=""))&&((token!=null)||(token!=" "))&&(bankid>0)){
 
 
 axios.post("vendordetails", {
   Log_id:logid,
   Token:token,
   Customer_id:bankid,

 })
 .then((response) => {


  //Invalid Session
  if((response.data.error)==100){ 
      //Remove Session Variables and redirect to login
     sessionStorage.removeItem("logStatus00");
     sessionStorage.removeItem("logId00");
     sessionStorage.removeItem("logToken00");
     sessionStorage.removeItem("BusyId00");
     sessionStorage.removeItem("CounterId00");
     sessionStorage.removeItem("Bankid00");


     window.location.replace("businesstools-login");
  }
  //Success Data Fetched
  if(response.data.successvar==1){

   //Setting Data
   setevendor_name(response.data.name);
   seteemail(response.data.email);
   setecontact(response.data.contact);
   setetrade_name(response.data.trade_name);
   seteaddress(response.data.address);
   setecity(response.data.city);
   setecstate(response.data.state);
   setecountry(response.data.country);
   setepincode(response.data.pincode);
   setetype(response.data.type);
   setecategory(response.data.category);
   setegstin(response.data.gstin);
   setelicense_no(response.data.license_no);

  }
  //Cannot Fetch Data
  else{


      document.getElementById("edit-form").style.display="none";

     //Setting Variables to empty 
     setevendor_name_er(" ");
     seteemail_er(" ");   
     setecontact_er(" ");    
     setetrade_name_er(" ");   
     seteaddress_er(" ");   
     setecity_er(" ");   
     setecstate_er(" ");   
     setecountry_er(" ");   
     setepincode_er(" ");   
     setetype_er(" ");   
     setecategory_er(" ");   
     setegstin_er(" ");   
     setelicense_no_er(" ");   
   
      document.getElementById("edit-error-card").style.display="block"; 
      sessionStorage.removeItem("Bankid00");
  }
 
 
 });
 
 }
 //User not Logedin
 else{

     //Checking if user loggedin
     if(((logstatus==null)||(logstatus==""))||((logid==null)||(logid==""))||((token==null)||(token==" "))){
 
 //Remove Session Variables and redirect to login
   sessionStorage.removeItem("logStatus00");
   sessionStorage.removeItem("logId00");
   sessionStorage.removeItem("logToken00");
   sessionStorage.removeItem("BusyId00");
   sessionStorage.removeItem("CounterId00");

   window.location.replace("businesstools-login");
     }
 
  }
 
 }
  
 //******************* GET VENDOR DATA BY ID FUNCTION END  ********************//

 

 //******************* EDIT VENDOR FUNCTION START ********************//
function editvendor(){

  //Setting Error Variables
     setevendor_name_er(" ");
     seteemail_er(" ");   
     setecontact_er(" ");    
     setetrade_name_er(" ");   
     seteaddress_er(" ");   
     setecity_er(" ");   
     setecstate_er(" ");   
     setecountry_er(" ");   
     setepincode_er(" ");   
     setetype_er(" ");   
     setecategory_er(" ");   
     setegstin_er(" ");   
     setelicense_no_er(" "); //setebank_id_er();

  const bankid = sessionStorage.getItem("Bankid00");
  //const trno = sessionStorage.getItem("Trno00");

  //Checking if user loggedin
  if(((logstatus!=null)||(logstatus!=""))&&((logid!=null)||(logid!=""))&&((token!=null)||(token!=" "))&&((bankid!=null)||(bankid!=" "))){
 
 
  axios.post("editvendordetails", {
   Log_id:logid,
   Token:token,
   Customer_id:bankid,
   Name : evendor_name,
   Email:eemail,
   Contact : econtact,
   Trade_name:etrade_name,
   Address:eaddress,
   City:ecity,
   State:ecstate,
   Country:ecountry,
   Pincode:epincode,
   Type:etype,
   Category:ecategory,
   Gstin:egstin,
   License_no:elicense_no
 })
 .then((response) => {


  //Invalid Session
  if((response.data.error)==100){ 
      //Remove Session Variables and redirect to login
     sessionStorage.removeItem("logStatus00");
     sessionStorage.removeItem("logId00");
     sessionStorage.removeItem("logToken00");
     sessionStorage.removeItem("BusyId00");
     sessionStorage.removeItem("BusyName00");
     sessionStorage.removeItem("CounterId00");
     sessionStorage.removeItem("Trno00");
     sessionStorage.removeItem("Bankid00");

     window.location.replace("businesstools-login");
  }

   //Validation Errors
 else if(response.data.validatorerror){
  setevendor_name_er(response.data.validatorerror.Vendor_name);
  seteemail_er(response.data.validatorerror.Email);
  setecontact_er(response.data.validatorerror.Contact);
  setetrade_name_er(response.data.validatorerror.Trade_name);
  seteaddress_er(response.data.validatorerror.Address);
  setecity_er(response.data.validatorerror.City);
  setecstate_er(response.data.validatorerror.State);
  setecountry_er(response.data.validatorerror.Country);
  setepincode_er(response.data.validatorerror.Pincode);
  setetype_er(response.data.validatorerror.Type);
  setecategory_er(response.data.validatorerror.Category);
  setegstin_er(response.data.validatorerror.Gstin);
  setelicense_no_er(response.data.validatorerror.License_no);
  seterror_msg("Cannot Update Vendor !"); 
}


//Invalid Entries
else if(response.data.error==102){ 
  
  setevendor_name_er(response.data.vendor_name_er);
  seteemail_er(response.data.email_er);
  setecontact_er(response.data.contact_er);
  setetrade_name_er(response.data.trade_name_er);
  seteaddress_er(response.data.bank_address_er);
  setecity_er(response.data.city_er);
  setecstate_er(response.data.state_er);
  setecountry_er(response.data.country_er);
  setepincode_er(response.data.pincode_er);
  setetype_er(response.data.type_er);
  setecategory_er(response.data.category_er);
  setegstin_er(response.data.gstin_er);
  setelicense_no_er(response.data.license_no_er);
  seterror_msg("Cannot Update Vendor !");   }


  //Invalid Entries
  else if(response.data.error==103){     seterror_msg(response.data.error_msg);  }

   //Transaction Updated Successfully
   else if(response.data.successvar==1){        
     //Setting Variables to empty 
     setevendor_name_er(" "); seteemail_er(" ");   setecontact_er(" "); setetrade_name_er(" "); seteaddress_er(" ");   setecity_er(" ");   
     setecstate_er(" ");    setecountry_er(" ");    setepincode_er(" ");    setetype_er(" ");    setecategory_er(" ");    setegstin_er(" ");   setelicense_no_er(" "); setebank_id_er();
     setevendor_name(" "); seteemail(" ");   setecontact(" "); setetrade_name(" "); seteaddress(" ");   setecity(" ");   
     setecstate(" ");    setecountry(" ");    setepincode(" ");    setetype(" ");    setecategory(" ");    setegstin(" ");   setelicense_no(" "); setebank_id();

     document.getElementById("edit-form").style.display="none"; 
    document.getElementById("edit-success-card").style.display="block";  }

   //Cannot Update Transaction
   else{  seterror_msg("Cannot Update Vendor !"); }
  

});
}
 //User not Logedin
 else{
 
 //Remove Session Variables and redirect to login
   sessionStorage.removeItem("logStatus00");
   sessionStorage.removeItem("logId00");
   sessionStorage.removeItem("logToken00");
   sessionStorage.removeItem("BusyId00");
   sessionStorage.removeItem("BusyName00");
   sessionStorage.removeItem("CounterId00");
   sessionStorage.removeItem("Trno00");
   sessionStorage.removeItem("Bankid00");

   window.location.replace("businesstools-login");
 
  }
 
 }
  
 //******************* EDIT VENDOR FUNCTION END ********************//

 
   
//******************* DELETE VENDOR FUNCTION START ********************//
function deletevendor(){

  const cashId=sessionStorage.getItem("DCashId00");
  const dtrno=sessionStorage.getItem("DTrno00");

  //Checking if user loggedin
  if(((logstatus!=null)||(logstatus!=""))&&((logid!=null)||(logid!=""))&&((token!=null)||(token!=" "))&&((cashId!=null)||(cashId!=" "))){
 
 axios.post("deletevendordetails", {
   Log_id:logid,
   Token:token,
   Customer_id:cashId,
   Tr_no:dtrno
 })
 .then((response) => {

  //Invalid Session
  if((response.data.error)==100){ 
      //Remove Session Variables and redirect to login
     sessionStorage.removeItem("logStatus00");
     sessionStorage.removeItem("logId00");
     sessionStorage.removeItem("logToken00");
     sessionStorage.removeItem("BusyId00");
     sessionStorage.removeItem("BusyName00");
     sessionStorage.removeItem("CounterId00");
     sessionStorage.removeItem("DCashId00");
     sessionStorage.removeItem("DTrno00");

     window.location.replace("businesstools-login");
  }

  //Counter Deleted Successfully
   if(response.data.successvar==1){        

      document.getElementById("delete-card").style.display="none";
      document.getElementById("delete-success-card").style.display="block";  
      sessionStorage.removeItem("DCashId");
      sessionStorage.removeItem("DTrno00");

  }
  
      //Cannot Delete Counter
    else{  
    document.getElementById("delete-card").style.display="none";
    document.getElementById("delete-error-card").style.display="block";   }
  

});
}
 //User not Logedin
 else{
 
 //Remove Session Variables and redirect to login
   sessionStorage.removeItem("logStatus00");
   sessionStorage.removeItem("logId00");
   sessionStorage.removeItem("logToken00");
   sessionStorage.removeItem("BusyId00");
   sessionStorage.removeItem("BusyName00");
   sessionStorage.removeItem("CounterId00");
   sessionStorage.removeItem("DCashId00");
   sessionStorage.removeItem("DTrno00");


   window.location.replace("businesstools-login");
 
  }
 
 }
  
 //******************* DELETE VENDOR FUNCTION END ********************//




//******************* GET SALES DATA IN EXCEL FUNCTION START  ********************//
function downloadExcel(){
 

  //Checking if user loggedin
  if(((logstatus!=null)||(logstatus!=""))&&((logid!=null)||(logid!=""))&&((token!=null)||(token!=" "))){
 
     //Fetching Filter Variables
      const $filter_customer_id = filter_customer_id;
      const $filter_customer_name = filter_customer_name;
      const $filter_email = filter_email;   
      const $filter_contact = filter_contact;
      const $filter_trade_name = filter_trade_name;
      const $filter_address = filter_address;
      const $filter_city = filter_city;
      const $filter_state = filter_state;
      const $filter_country = filter_country;
      const $filter_category = filter_category;
      const $filter_type = filter_type;


 axios.post("vendorslistinexcel", {
   Log_id:logid,
   Token:token,
   Busy_id:busyid,
   Counter_id:counterid,
   Sn_start :0,
   Sn_end :0,
   Sn_total :0,
   Sn_limit :0,
  
   //Filters
   Filter_val : filter_val,
  
   Filter_customer_id : $filter_customer_id,
   Filter_customer_name : $filter_customer_name,
   Filter_email : $filter_email,
   Filter_contact : $filter_contact,
   Filter_trade_name : $filter_trade_name,
   Filter_address : $filter_address,
   Filter_city : $filter_city,
   Filter_state : $filter_state,
   Filter_country : $filter_country,
   Filter_category : $filter_category,
   Filter_type : $filter_type,

  
//Code Edits for pagination
'page' : pageNumber




 })
 .then((response) => {


      //Invalid Session
  if((response.data.error)==100){ 
      //Remove Session Variables and redirect to login
     sessionStorage.removeItem("logStatus00");
     sessionStorage.removeItem("logId00");
     sessionStorage.removeItem("logToken00");
     sessionStorage.removeItem("logName00");

     window.location.replace("/");
  }
  //Success Data Fetched
  if(response.data.successvar==1){

//Setting Data
   const exceldata =response.data.data;
   
   // Convert JSON data to Excel worksheet
   const worksheet = XLSX.utils.json_to_sheet(exceldata);
   
   // Create a new workbook and add the worksheet
   const workbook = XLSX.utils.book_new();
   XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");
   
   // Convert the workbook to a binary array
   const excelBuffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" });
   
   // Create a Blob from the binary data and trigger a download
   const excel_data = new Blob([excelBuffer], { type: "application/octet-stream" });
   saveAs(excel_data, "data.xlsx");
  }
  //Cannot Fetch Data
  else{
    seterrorvar("Cannot Download Excel File !");
  } 
 });
 
 }
 //User not Logedin
 else{
 
 //Remove Session Variables and redirect to login
   sessionStorage.removeItem("logStatus00");
   sessionStorage.removeItem("logId00");
   sessionStorage.removeItem("logToken00");
   sessionStorage.removeItem("BusyId00");
   sessionStorage.removeItem("CounterId00");

   window.location.replace("businesstools-login");
 
  }
 
 }
  
 //******************* GET VENDORS DATA IN EXCEL FUNCTION END  ********************//


return(
    <>
<html lang="en">
  <head>
    {/*} Required meta tags */}
    <meta charset="utf-8" />
    <meta name="viewport" content="width=device-width, initial-scale=1, shrink-to-fit=no" />
    <title>React App</title>
    {/*} plugins:css */}
    <link rel="stylesheet" href="panel/assets/vendors/mdi/css/materialdesignicons.min.css" />
    <link rel="stylesheet" href="panel/assets/vendors/flag-icon-css/css/flag-icon.min.css" />
    <link rel="stylesheet" href="panel/assets/vendors/css/vendor.bundle.base.css" />
    {/*} endinject */}
    {/*} Plugin css for this page */}
    <link rel="stylesheet" href="panel/assets/vendors/jquery-bar-rating/css-stars.css" />
    <link rel="stylesheet" href="panel/assets/vendors/font-awesome/css/font-awesome.min.css" />
    {/*} End plugin css for this page */}
    {/*} inject:css */}
    {/*} endinject */}
    {/*} Layout styles */}
    <link rel="stylesheet" href="panel/assets/css/demo_1/style.css" />
    {/*} End layout styles */}
    <link rel="shortcut icon" href="panel/assets/images/favicon.png" />
  </head>
  <body>
    <div class="container-scroller">

      <Sidebar />
    <div class="container-fluid page-body-wrapper">


       <Navbar />
        {/*} partial */}
        <div class="main-panel">

      

             {/* SUCCESS CARD START */}
          <div class="d-flex justify-content-center">
          <div class="col-md-6 grid-margin stretch-card" style={{position:"fixed",zIndex:"3",marginTop:"4rem",display:"none"}} id="success-card">
                <div class="card">
                  <div class="card-body">
                    <h4 class="card-title  text-success">New Vendor Added Successfully !!!</h4>
                  
                    <blockquote class="blockquote">
                      <p class="mb-0"> Click the following button to close.</p>
                      <a href="/spadminpanel-dashboard-vendors"><button class="mt-3 btn btn-outline-danger">Close</button></a>
                    </blockquote>
                  </div>
              
                </div>
              </div>
              </div>
              {/* SUCCESS CARD END */}
              {/* EDIT SUCCESS CARD START */}
             <div class="d-flex justify-content-center">
             <div class="col-md-6 grid-margin stretch-card" style={{position:"fixed",zIndex:"3",marginTop:"4rem",display:"none"}} id="edit-success-card">
                <div class="card">
                  <div class="card-body">
                    <h4 class="card-title  text-success">Vendor Updated Successfully !!!</h4>
                  
                    <blockquote class="blockquote">
                      <p class="mb-0"> Click the following button to close.</p>
                      <button class="mt-3 btn btn-outline-danger" onClick={()=>{ document.getElementById("edit-success-card").style.display="none"; }}>Close</button>
                    </blockquote>
                  </div>
              
                </div>
              </div>
              </div>
              {/* EDIT SUCCESS CARD END */}
               {/* EDIT ERROR CARD START */}
            <div class="d-flex justify-content-center">
            <div class="col-md-6 grid-margin stretch-card" style={{position:"fixed",zIndex:"3",marginTop:"4rem",display:"none"}} id="edit-error-card">
                <div class="card">
                  <div class="card-body">
                    <h4 class="card-title  text-danger">Cannot Fetch Data !!!</h4>
                  
                    <blockquote class="blockquote">
                      <p class="mb-0"> Click the following button to close.</p>
                      <button class="mt-3 btn btn-outline-danger" onClick={()=>{ document.getElementById("edit-error-card").style.display="none"; }}>Close</button>
                    </blockquote>
                  </div>
              
                </div>
              </div>
              </div>
              {/* EDIT ERROR CARD END */}

                  {/* DELETE CARD START */}
        <div class="d-flex justify-content-center">
          <div class="col-md-6 grid-margin stretch-card" style={{position:"fixed",zIndex:"3",marginTop:"4rem",display:"none"}} id="delete-card">
                <div class="card">
                  <div class="card-body">
                    <h4 class="card-title  text-danger">Are you sure you want to delete this vendor?</h4>
                  
                    <blockquote class="blockquote">
                      <p class="mb-0"> This action cannot be reversed. You will lose all your data related to this transaction if you wish to continue this action.</p>
                      <button class="mt-3 btn btn-outline-success" onClick={deletevendor}>Yes, I Know! Delete Transaction.</button>
                      <button class="mt-3 btn btn-outline-danger" style={{marginLeft:"1rem"}} onClick={()=>{  
                      //Cancel Delete and remove Counter_id
                      sessionStorage.removeItem("DCashId00");     sessionStorage.removeItem("DTrno00");  document.getElementById('delete-card').style.display = 'none'; }}>No, Don't Delete Transaction.</button>
                    </blockquote>
                  </div>
              
                </div>
              </div>
              </div>
              {/* DELETE CARD END */}
              {/* DELETE SUCCESS CARD START */}
        <div class="d-flex justify-content-center">
          <div class="col-md-6 grid-margin stretch-card" style={{position:"fixed",zIndex:"3",marginTop:"4rem",display:"none"}} id="delete-success-card">
                <div class="card">
                  <div class="card-body">
                    <h4 class="card-title  text-success">Transaction Deleted Successfully !!!</h4>
                  
                    <blockquote class="blockquote">
                      <p class="mb-0"> Click the following button to close.</p>
                      <button class="mt-3 btn btn-outline-danger" onClick={()=>{ document.getElementById("delete-success-card").style.display="none"; }}>Close</button>
                    </blockquote>
                  </div>
              
                </div>
              </div>
              </div>
              {/* DELETE SUCCESS CARD END */}
               {/*  DELETE ERROR CARD START */}
        <div class="d-flex justify-content-center">
          <div class="col-md-6 grid-margin stretch-card" style={{position:"fixed",zIndex:"3",marginTop:"4rem",display:"none"}} id="delete-error-card">
                <div class="card">
                  <div class="card-body">
                    <h4 class="card-title  text-danger">Cannot Delete Transaction !!!</h4>
                  
                    <blockquote class="blockquote">
                      <p class="mb-0"> Click the following button to close.</p>
                      <button class="mt-3 btn btn-outline-danger" onClick={()=>{ document.getElementById("delete-error-card").style.display="none"; }}>Close</button>
                    </blockquote>
                  </div>
              
                </div>
              </div>
              </div>
              {/* DELETE ERROR CARD END */}


          <div class="content-wrapper pb-0">
          
          {/* ADD VENDOR SECTION START */}
          <div class="row">
              <div class="col-12 grid-margin create-form" id="create-form">
              <Add_vendor /> 
              </div>
              {/* ADD VENDOR SECTION END */}
            
          </div>

            <div class="page-header flex-wrap">
            <div class="header-left"></div>
              <div class="header-right d-flex flex-wrap mt-2 mt-sm-0">
                <div class="d-flex align-items-center">
                  <a href="#">
                    <p class="m-0 pe-3">Vendors</p>
                  </a>
                  <a class="ps-3 me-4" href="#">
                  {/*}  <p class="m-0">ADE-00234</p> */}
                  </a>
                </div>
                <button type="button" class="btn btn-primary mt-2 mt-sm-0 btn-icon-text" onClick={()=>{ 
               const createForm = document.getElementById('create-form');
               const currentDisplay = createForm.style.display;
               createForm.style.display = currentDisplay === 'none' ? 'block' : 'none'; }}>
                  <i class="mdi mdi-plus-circle"></i> Add New Vendor </button>

              </div>
            </div>


             {/* VENDOR EDIT FORM START */}
             <div class="row">
              <div class="col-12 grid-margin create-form" id="edit-form" style={{display:"none"}}>
              <div class="card">
                <div class="d-flex justify-content-between">
                    <div></div>
                    <div>
                    
                      <button type="button" class="btn btn-social-icon" onClick={()=>{ 
                         //close edit form button
                         document.getElementById("edit-form").style.display="none";
                        //Setting Variables to empty
                        //Setting Variables to empty 
                        setevendor_name_er(" "); seteemail_er(" ");   setecontact_er(" "); setetrade_name_er(" "); seteaddress_er(" ");   setecity_er(" ");   
                        setecstate_er(" ");    setecountry_er(" ");    setepincode_er(" ");    setetype_er(" ");    setecategory_er(" ");    setegstin_er(" ");   setelicense_no_er(" "); setebank_id_er();
                        setevendor_name(" "); seteemail(" ");   setecontact(" "); setetrade_name(" "); seteaddress(" ");   setecity(" ");   
                        setecstate(" ");    setecountry(" ");    setepincode(" ");    setetype(" ");    setecategory(" ");    setegstin(" ");   setelicense_no(" "); setebank_id();
                  
                        sessionStorage.removeItem("Bankid00");
                        sessionStorage.removeItem("Trno00"); }}>
                      <i class="mdi mdi-close-box text-danger" style={{fontSize:"2rem"}}></i>
                      </button>
                      </div>
                    </div>
                  <div class="card-body">
                    <h4 class="card-title">Edit Vendor</h4>
                    <div class="form-sample">
                      <p class="card-description">edit vendor details here</p>
                       <div class="row">
                        <div class="col-md-6">
                          <div class="form-group row">
                            <label class="col-sm-3 col-form-label">Vendor Name<code>*</code></label>
                            <div class="col-sm-9">
                              <input type="text" class="form-control" placeholder="Manoj Kumar" id="evendor_name" value={evendor_name}  />
                              <small style={{fontSize:"0.7rem", color:"#7b7b7b", textAlign:"left"}}>this field cannot be changed</small>
                              <code>{evendor_name_er}</code>
                            </div>
                          </div>
                        </div>
                        <div class="col-md-6">
                          <div class="form-group row">
                            <label class="col-sm-3 col-form-label">Vendor Type<code>*</code></label>
                            <div class="col-sm-9">
                              <select class="form-control" style={{padding:"1rem"}} placeholder="Select Vendor Type" id="etype" value={etype} onChange={updateetype}>
                              <option value="">Select vendor Type</option>
                              <option value="sole proprietorship">sole proprietorship</option>
                              <option value="private limited company">private limited company</option>
                              <option value="registered partnership">registered partnership</option>
                              <option value="unregistered partnership">unregistered partnership</option>
                              <option value="other">other</option>
                              </select>
                              <code>{etype_er}</code>
                            </div>
                          </div>
                        </div>   
                        </div>
                        <div class="row">
                        <div class="col-md-6">
                          <div class="form-group row">
                            <label class="col-sm-3 col-form-label">Trade Name<code>*</code></label>
                            <div class="col-sm-9">
                              <input type="text" class="form-control" placeholder="ABC Private Limited" id="etrade_name" value={etrade_name} onChange={updateetrade_name} />
                             <code>{etrade_name_er}</code>
                            </div>
                          </div>
                        </div>
                        <div class="col-md-6">
                          <div class="form-group row">
                            <label class="col-sm-3 col-form-label">Email</label>
                            <div class="col-sm-9">
                              <input type="email" class="form-control" placeholder="abccompany@gmail.com" id="eemail" value={eemail} onChange={updateeemail} />
                             <code>{eemail_er}</code>
                            </div>
                          </div>
                        </div>                     
                      </div>
                       <div class="row">
                        <div class="col-md-6">
                          <div class="form-group row">
                            <label class="col-sm-3 col-form-label">Contact</label>
                            <div class="col-sm-9">
                              <input type="text" class="form-control" placeholder="ABC Private Limited" id="econtact" value={econtact} onChange={updateecontact} />
                             <code>{econtact_er}</code>
                            </div>
                          </div>
                        </div>
                        <div class="col-md-6">
                          <div class="form-group row">
                            <label class="col-sm-3 col-form-label">Category</label>
                            <div class="col-sm-9">
                              <input type="text" class="form-control" placeholder="type category" id="ecategory" value={ecategory} onChange={updateecategory} />
                             <code>{ecategory_er}</code>
                            </div>
                          </div>
                        </div>                     
                      </div>
                      <div class="row">
                        <div class="col-md-6">
                          <div class="form-group row">
                            <label class="col-sm-3 col-form-label">GSTIN</label>
                            <div class="col-sm-9">
                              <input type="text" class="form-control" placeholder="AAJ1029229222" id="egstin" value={egstin} onChange={updateegstin} autoCapitalize='on' />
                             <code>{egstin_er}</code>
                            </div>
                          </div>
                        </div>
                        <div class="col-md-6">
                          <div class="form-group row">
                            <label class="col-sm-3 col-form-label">License No.</label>
                            <div class="col-sm-9">
                              <input type="text" class="form-control" placeholder="License no" id="elicense_no" value={elicense_no} onChange={updateelicense_no} />
                             <code>{elicense_no_er}</code>
                            </div>
                          </div>
                        </div>                     
                      </div>
                      <div class="form-group">
                        <label for="exampleTextarea1">Address</label>
                        <textarea  class="form-control"  rows="2" id="eaddress" value={eaddress} onChange={updateeaddress}></textarea>
                      <code>{eaddress_er}</code>
                      </div>
                        <div class="row">
                        <div class="col-md-6">
                          <div class="form-group row">
                            <label class="col-sm-3 col-form-label">City</label>
                            <div class="col-sm-9">
                              <input type="text" class="form-control" placeholder="Satna" id="ecity" value={ecity} onChange={updateecity} />
                             <code>{ecity_er}</code>
                            </div>
                          </div>
                        </div>
                        <div class="col-md-6">
                          <div class="form-group row">
                            <label class="col-sm-3 col-form-label">State</label>
                            <div class="col-sm-9">
                              <input type="text" class="form-control" placeholder="Madhya Pradesh" id="ecstate" value={ecstate} onChange={updateecstate} />
                             <code>{ecstate_er}</code>
                            </div>
                          </div>
                        </div>                     
                      </div>
                        <div class="row">
                        <div class="col-md-6">
                          <div class="form-group row">
                            <label class="col-sm-3 col-form-label">Country</label>
                            <div class="col-sm-9">
                              <input type="text" class="form-control" placeholder="India" id="ecountry" value={ecountry} onChange={updateecountry} />
                             <code>{ecountry_er}</code>
                            </div>
                          </div>
                        </div>
                        <div class="col-md-6">
                          <div class="form-group row">
                            <label class="col-sm-3 col-form-label">Pincode</label>
                            <div class="col-sm-9">
                              <input type="text" class="form-control" placeholder="epincode" id="epincode" value={epincode} onChange={updateepincode} />
                             <code>{epincode_er}</code>
                            </div>
                          </div>
                        </div>                     
                      </div>
                        
                      
                        <button class="btn btn-primary" style={{fontWeight:"bold"}} onClick={editvendor}>Submit</button>
                      
                       
    
                     
                   
                    </div>
                  </div>
                </div>
              </div>
              </div>
              {/* VENDOR EDIT FORM END */}


              {/* VENDOR LIST SECTION START */}
             <div class="col-lg-12 grid-margin stretch-card">
                <div class="card">
                  <div class="card-body">
                    <h4 class="card-title">Vendors</h4>
                    <p class="card-description">vendor details
                    </p>

    {/* FILTER SECTION START */}
    <hr/>
                            <div id="filter-top-card" class="row col-12" style={{textAlign:"left",display:"none"}}>
                            <div class="d-flex justify-content-between">
                            <div>
                            <h4 style={{padding:'1rem'}}>Filters</h4>
                           </div>
                           <div>
                    
                           <button type="button" class="btn btn-social-icon" onClick={()=>{ document.getElementById("filter-top-card").style.display="none"; }}>
                           <i class="mdi mdi-close-box text-danger" style={{fontSize:"2rem"}}></i>
                           </button>
                           </div>
                           </div>
        
                        <div class="row">
                        <div class="col-md-4">
                          <div class="form-group row">
                            <label class="col-sm-4 col-form-label">Vendor Name</label>
                            <div class="col-sm-8">
                              <input type="text" class="form-control" id="filter_customer_name" value={filter_customer_name} onChange={updatefilter_customer_name}  />
                              <code>{filter_customer_name_er}</code>
                            </div>
                          </div>
                        </div>
                        <div class="col-md-4">
                          <div class="form-group row">
                            <label class="col-sm-4 col-form-label">Email</label>
                            <div class="col-sm-8">
                              <input type="text" class="form-control"  id="filter_email" value={filter_email} onChange={updatefilter_email}  />
                              <code>{filter_email_er}</code>
                            </div>
                          </div>
                        </div>
                        <div class="col-md-4">
                          <div class="form-group row">
                            <label class="col-sm-4 col-form-label">Contact</label>
                            <div class="col-sm-8">
                              <input type="text" class="form-control" id="filter_contact" value={filter_contact} onChange={updatefilter_contact}  />
                              <code>{filter_contact_er}</code>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-md-4">
                          <div class="form-group row">
                            <label class="col-sm-4 col-form-label">Trade Name</label>
                            <div class="col-sm-8">
                              <input type="text" class="form-control" id="filter_trade_name" value={filter_trade_name} onChange={updatefilter_trade_name}  />
                              <code>{filter_trade_name_er}</code>
                            </div>
                          </div>
                        </div>
                        <div class="col-md-4">
                          <div class="form-group row">
                            <label class="col-sm-4 col-form-label">Address</label>
                            <div class="col-sm-8">
                              <input type="text" class="form-control"  id="filter_address" value={filter_address} onChange={updatefilter_address}  />
                              <code>{filter_address_er}</code>
                            </div>
                          </div>
                        </div>
                        <div class="col-md-4">
                          <div class="form-group row">
                            <label class="col-sm-4 col-form-label">City</label>
                            <div class="col-sm-8">
                              <input type="text" class="form-control" id="filter_city" value={filter_city} onChange={updatefilter_city}  />
                              <code>{filter_city_er}</code>
                            </div>
                          </div>
                        </div>
                      </div>
                       <div class="row">
                        <div class="col-md-4">
                          <div class="form-group row">
                            <label class="col-sm-4 col-form-label">State</label>
                            <div class="col-sm-8">
                              <input type="text" class="form-control" id="filter_state" value={filter_state} onChange={updatefilter_state}  />
                              <code>{filter_state_er}</code>
                            </div>
                          </div>
                        </div>
                        <div class="col-md-4">
                          <div class="form-group row">
                            <label class="col-sm-4 col-form-label">Type</label>
                            <div class="col-sm-8">
                             <select class="form-control" style={{padding:"1rem"}} placeholder="Select Vendor Type" id="filter_type" value={filter_type} onChange={updatefilter_type}>
                              <option value="">Select vendor Type</option>
                              <option value="sole proprietorship">sole proprietorship</option>
                              <option value="private limited company">private limited company</option>
                              <option value="registered partnership">registered partnership</option>
                              <option value="unregistered partnership">unregistered partnership</option>
                              <option value="other">other</option>
                              </select>
                              <code>{filter_type_er}</code>
                            </div>
                          </div>
                        </div>
                        <div class="col-md-4">
                          <div class="form-group row">
                            <label class="col-sm-4 col-form-label">Category</label>
                            <div class="col-sm-8">
                              <input type="text" class="form-control" id="filter_category" value={filter_category} onChange={updatefilter_category}  />
                              <code>{filter_category_er}</code>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="form-group">
                      <button class="btn btn-primary" onClick={()=>{ setfilter_val(1); getData(); }}>Apply Filters</button>
                      <button class="btn btn-danger" style={{marginLeft:"1rem"}} onClick={()=>{ setfilter_val(0); getData(); }}>Remove Filters</button>
                      </div>

                            <hr/>                      
                            </div>
                            
                            {/* FILTER SECTION END */}

                    <div class="col-12" style={{marginBottom:"2rem"}}>
                        <div class="template-demo d-flex justify-content-between">
                        <div></div>

                        {/* COLUMNS MANAGEMENT DROPDOWN START */}
                          <div class="dropdown">
                          <button class="btn btn-warning" onClick={()=>{ document.getElementById("filter-top-card").style.display="block"; }}><i class="mdi mdi-filter-outline"></i></button>
                      {/*}      <button class="btn btn-primary dropdown-toggle" style={{marginLeft:"1rem"}} type="button" id="dropdownMenuIconButton1" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                            <i class="mdi mdi-table-large"></i>
                            </button>
                      */}
                          </div>
                          {/* COLUMNS MANAGEMENT DROPDOWN END */}

                          </div>
                          </div>

                    <div class="table-responsive" id="reports" ref={componentRef}>
                      <table class="table table-bordered table-hover">
                        <thead>
                          <tr >
                            <th  style={{fontWeight:"bold"}} hidden={cd_col1_val==1}>#</th>
                            <th  style={{fontWeight:"bold"}} hidden={cd_col1_val==1}>Vendor Name</th>
                            <th  style={{fontWeight:"bold"}} hidden={cd_col2_val==1}>Trade Name</th>
                            <th  style={{fontWeight:"bold"}} hidden={cd_col3_val==1}>GSTIN</th>
                            <th  style={{fontWeight:"bold"}} hidden={cd_col5_val==1}>Contact</th>
                            <th  style={{fontWeight:"bold"}} hidden={cd_col4_val==1}>Email</th>
                            <th  style={{fontWeight:"bold"}} hidden={cd_col5_val==1}>Type</th>
                            <th  style={{fontWeight:"bold"}} hidden={cd_col6_val==1}>Category</th>
                            <th  style={{fontWeight:"bold"}} hidden={cd_col7_val==1}>License No.</th>
                            <th  style={{fontWeight:"bold"}} hidden={cd_col8_val==1}>Address</th>
                            <th  style={{fontWeight:"bold"}} hidden={cd_col8_val==1}>City</th>
                            <th  style={{fontWeight:"bold"}} hidden={cd_col8_val==1}>State</th>
                            <th  style={{fontWeight:"bold"}} hidden={cd_col8_val==1}>Pincode</th>
                            <th  style={{fontWeight:"bold"}} hidden={cd_col9_val==1}>Updated By</th>
                            <th  style={{fontWeight:"bold"}} hidden={cd_col10_val==1}>Updated At</th>
                            <th  style={{fontWeight:"bold"}} hidden={cd_col11_val==1}></th>
                            <th  style={{fontWeight:"bold"}} hidden={cd_col12_val==1}></th>
                          </tr>
                        </thead>
                        <tbody>
                        {
                       data.map((curElm,ind)=>{

                         return(
                         <>
                       
                        <tr key={curElm.Id}>
                            <td>{ind+1}</td>
                            <td hidden={(cd_col1_val==1)}>{curElm.Vendor_name}</td>
                            <td hidden={cd_col2_val==1}>{curElm.Trade_name}</td>
                            <td hidden={cd_col3_val==1}>{curElm.Gstin}</td>
                            <td hidden={cd_col3_val==1}>{curElm.Contact}</td>
                            <td hidden={cd_col4_val==1}>{curElm.Email}</td>
                            <td hidden={cd_col4_val==1}>{curElm.Type}</td>
                            <td hidden={cd_col4_val==1}>{curElm.Category}</td>                   
                            <td hidden={cd_col4_val==1}>{curElm.License_no}</td>
                            <td hidden={cd_col4_val==1}>{curElm.Address}</td>
                            <td hidden={cd_col4_val==1}>{curElm.City}</td>
                            <td hidden={cd_col4_val==1}>{curElm.State}</td>
                            <td hidden={cd_col4_val==1}>{curElm.Pincode})</td>
                            <td hidden={cd_col9_val==1}>{curElm.Updated_by}</td>
                            <td hidden={cd_col10_val==1}>{curElm.Date_updated} ({curElm.Time_updated})</td>
                            <td hidden={cd_col11_val==1}><i class="mdi mdi-pencil-box text-warning" style={{fontSize:"1.4rem"}} onClick={()=>{ 
                        //Setting Bank Id and Redirect to Edit
                      sessionStorage.setItem("Bankid00",curElm.Vendor_id);getcounterdatabyId();document.getElementById('edit-form').style.display = 'block'; }}></i></td>
                            <td hidden={cd_col12_val==1}><i class="mdi mdi-delete-forever text-danger" style={{fontSize:"1.4rem"}} onClick={()=>{ 
                        //Setting Bank Id for Delete
                      sessionStorage.setItem("DCashId00",curElm.Vendor_id);      sessionStorage.setItem("DTrno00",curElm.Tr_no); document.getElementById('delete-card').style.display = 'block'; }}></i></td>
                          </tr>
                          </>
                         )
                         }
                       
                             )
                         }
                          
                      
                        </tbody>
                      </table>
                    </div>
                      {/* PAGINATION SECTION START */}
                      <div>
                       <div class="col-12" style={{marginBottom:"2rem",marginTop:"1rem"}}>
                        <div class="template-demo d-flex justify-content-between">
                        <div></div>

                       
                          <div class="dropdown">
                          <button class="btn" onClick={()=>{ const pgNumber=pageNumber-1; setpageNumber(pgNumber); getData();  }}><i class="mdi mdi-arrow-left-drop-circle text-success"></i></button>
                          <button class="btn" onClick={()=>{ const pgNumber=pageNumber+1; setpageNumber(pgNumber); getData();  }}><i class="mdi mdi-arrow-right-drop-circle text-success"></i></button>
                          </div>
                          </div>
                          </div>
                    </div>
                    {/* PAGINATION SECTION END */}

                    <button class="btn btn-light" onClick={handlePrint}><i class="mdi mdi-cloud-print text-dark"></i></button>
                    <button class="btn btn-light" onClick={downloadExcel}><i class="mdi mdi-file-excel text-dark"></i></button>


                  </div>
                </div>
              </div>
              {/* SALES LIST SECTION END */}


             

            
          </div>
          {/*} content-wrapper ends */}
          {/*} partial:partials/_footer.html */}
        {/*}  <footer class="footer">
            <div class="d-sm-flex justify-content-center justify-content-sm-between">
              <span class="text-muted text-center text-sm-left d-block d-sm-inline-block">Copyright © 2023 <a href="https://www.bootstrapdash.com/" target="_blank">BootstrapDash</a>. All rights reserved.</span>
              <span class="float-none float-sm-right d-block mt-1 mt-sm-0 text-center">Hand-crafted & made with <i class="mdi mdi-heart text-danger"></i></span>
            </div>
          </footer> */}
          {/*} partial */}
        </div>
        {/*} main-panel ends */}
      </div>
      {/*} page-body-wrapper ends */}
    </div>
    {/*} container-scroller */}
    {/*} plugins:js */}
    <script src="panel/assets/vendors/js/vendor.bundle.base.js"></script>
    {/*} endinject */}
    {/*} Plugin js for this page */}
    <script src="panel/assets/vendors/jquery-bar-rating/jquery.barrating.min.js"></script>
    <script src="panel/assets/vendors/chart.js/Chart.min.js"></script>
    <script src="panel/assets/vendors/flot/jquery.flot.js"></script>
    <script src="panel/assets/vendors/flot/jquery.flot.resize.js"></script>
    <script src="panel/assets/vendors/flot/jquery.flot.categories.js"></script>
    <script src="panel/assets/vendors/flot/jquery.flot.fillbetween.js"></script>
    <script src="panel/assets/vendors/flot/jquery.flot.stack.js"></script>
    <script src="panel/assets/js/jquery.cookie.js" type="text/javascript"></script>
    {/*} End plugin js for this page */}
    {/*} inject:js */}
    <script src="panel/assets/js/off-canvas.js"></script>
    <script src="panel/assets/js/hoverable-collapse.js"></script>
    <script src="panel/assets/js/misc.js"></script>
    <script src="panel/assets/js/settings.js"></script>
    <script src="panel/assets/js/todolist.js"></script>
    {/*} endinject */}
    {/*} Custom js for this page */}
    <script src="panel/assets/js/dashboard.js"></script>
    {/*} End custom js for this page */}
  </body>
</html>
</>
);

//}

}
export default SP_vendors;